import { constantsTypes } from '../reduxConstants'

export const setMobileFilterValues = (value)=>{
    return{
        type: constantsTypes.MOBILE_FILTER,
        value : value
    }
}